import React, { useRef, useState } from 'react';
import Iconify from 'src/components/Iconify';
import v2_actionUploadS3 from 'src/actions/v2/global/actionUploadS3';
import { DOCUMENTO_DESIGN as D } from '../EditorDocumento.design';

export default function CabecalhoEditavel({ layout, onChangeLayout, readOnly }) {
  const fileInputRef = useRef(null);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const empresa = layout?.empresa || {};

  const handleLogoSelect = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setUploadingLogo(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await v2_actionUploadS3(formData, '?path=plataforma/propostas');
      const url = res?.data?.data?.location;
      if (url) onChangeLayout({ logo_url: url });
    } catch (err) {
      console.error('Erro ao enviar logo:', err);
    } finally {
      setUploadingLogo(false);
    }
  };

  const setEmpresa = (patch) => onChangeLayout({ empresa: { ...empresa, ...patch } });

  return (
    <div className="mb-8">
      <div className="flex items-start justify-between mb-6">
        <div className="flex-1">
          {layout?.logo_url ? (
            <div className="relative group inline-block">
              <img src={layout.logo_url} alt="Logo" className="h-14 object-contain" />
              {!readOnly && (
                <button
                  type="button"
                  onClick={() => fileInputRef.current?.click()}
                  title="Trocar logo"
                  className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 rounded transition-opacity"
                >
                  <Iconify icon="mdi:pencil-outline" width={16} className="text-white" />
                </button>
              )}
            </div>
          ) : !readOnly ? (
            <button
              type="button"
              onClick={() => fileInputRef.current?.click()}
              disabled={uploadingLogo}
              className={D.logoButton}
            >
              <Iconify icon={uploadingLogo ? 'mdi:loading' : 'mdi:image-outline'} width={16} className={uploadingLogo ? 'animate-spin' : ''} />
              {uploadingLogo ? 'Enviando...' : 'Adicionar logo'}
            </button>
          ) : null}
          <input ref={fileInputRef} type="file" accept="image/*" className="hidden" onChange={handleLogoSelect} />
        </div>

        {/* Dados da empresa como texto do documento: campos silenciosos, alinhados à
            direita, com o placeholder na tipografia real (sem caixa de formulário). */}
        <div className="text-right text-sm text-gray-600 dark:text-[#ABABAD] space-y-0.5 min-w-[220px]">
          {readOnly ? (
            <>
              {empresa.nome && <p className="font-semibold text-gray-900 dark:text-[#D1D2D3]">{empresa.nome}</p>}
              {empresa.cnpj && <p>{empresa.cnpj}</p>}
              {empresa.telefone && <p>{empresa.telefone}</p>}
            </>
          ) : (
            <>
              <input
                value={empresa.nome || ''}
                onChange={e => setEmpresa({ nome: e.target.value })}
                placeholder="Nome da empresa"
                aria-label="Nome da empresa"
                className={`${D.docInput} w-full text-right text-sm font-semibold`}
              />
              <input
                value={empresa.cnpj || ''}
                onChange={e => setEmpresa({ cnpj: e.target.value })}
                placeholder="CNPJ"
                aria-label="CNPJ"
                className={`${D.docInput} w-full text-right text-xs !text-gray-600`}
              />
              <input
                value={empresa.telefone || ''}
                onChange={e => setEmpresa({ telefone: e.target.value })}
                placeholder="Telefone"
                aria-label="Telefone da empresa"
                className={`${D.docInput} w-full text-right text-xs !text-gray-600`}
              />
            </>
          )}
        </div>
      </div>

      <div
        className="h-1 rounded-full"
        style={{ background: `linear-gradient(90deg, ${layout?.tema_cor || '#7C3AED'}, transparent)` }}
      />
    </div>
  );
}
